// Dual-pad POS: the master pad keeps cart, categories and checkout; the slave pad shows the first products
// of the master's category (as many as fit on its screen) and sends taps back, and the master shows the
// rest. Both join one pair room on the POS WebSocket server.
(function () {
  const DUAL_TAP_ACK_TIMEOUT = 1500;
  const DUAL_PING_INTERVAL = 10000;
  const DUAL_PONG_TIMEOUT = 25000;
  const DUAL_ALL_CATEGORY = 'all';
  const DUAL_MAX_PAGES = 100;

  $(document).ready(function () {
    const $pos = $('#classic-location-products');
    if ($('body').attr('p') !== 'events' || !$pos.length) {
      return;
    }

    const role = $pos.attr('data-dual-role');
    if (role === 'master' || role === 'slave') {
      // Header styles: the header is outside the POS container (see _dualScreen.scss)
      $('body').addClass('dual-screen-' + role);
    }
    let messages = {};
    try {
      messages = JSON.parse($pos.attr('data-dual-messages') || '{}');
    } catch (e) {
      messages = {};
    }

    if (role === 'master') {
      initDualMaster($pos, messages);
    } else if (role === 'slave') {
      initDualSlave($pos, messages);
    }
  });

  /**
   * One WebSocket per pad for the pair room, separate from the customer screen socket.
   * A fresh token is fetched on every (re)connect.
   */
  function createDualConnection(handlers) {
    let socket = null;
    let joined = false;
    let stopped = false;
    let lastSeen = 0;
    let pingTimer = null;
    let reconnectTimer = null;
    let reconnectDelay = 1000;

    function socketUrl() {
      const hostname = window.location.hostname;
      return location.protocol === 'https:'
        ? `wss://${hostname}/ws`
        : `ws://${hostname}:9090/`;
    }

    function connect() {
      if (stopped) {
        return;
      }
      $.ajax({
        type: 'GET',
        url: '/api/v1/private/dual-screen/connection',
        cache: false,
      })
        .done(function (data) {
          if (!data || !data.token) {
            handlers.onUnpaired(data || {});
            return;
          }
          handlers.onInfo(data);
          open(data.token);
        })
        .fail(function (xhr) {
          if (xhr.responseJSON && xhr.responseJSON.redirect_url) {
            return;
          }
          scheduleReconnect();
        });
    }

    function open(token) {
      const ws = new WebSocket(socketUrl());
      socket = ws;
      lastSeen = Date.now();

      ws.onopen = function () {
        ws.send(JSON.stringify({ type: 'dual.hello', token: token }));
        startPing();
      };

      ws.onmessage = function (event) {
        let data;
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          return;
        }
        if (!data || typeof data.type !== 'string' || data.type.indexOf('dual.') !== 0) {
          return;
        }
        lastSeen = Date.now();

        if (data.type === 'dual.pong') {
          return;
        }
        if (data.type === 'dual.welcome') {
          joined = true;
          reconnectDelay = 1000;
        }
        if (data.type === 'dual.replaced') {
          // Another tab or a reload of this pad took over the pair room
          stopped = true;
        }
        if (data.type === 'dual.error') {
          if (data.code === 'invalid_token' || data.code === 'not_joined') {
            drop();
          }
          return;
        }
        handlers.onMessage(data);
      };

      ws.onclose = function () {
        if (socket === ws) {
          drop();
        }
      };
    }

    // Forget the socket at once (a dead network can delay onclose by minutes) and reconnect
    function drop() {
      const ws = socket;
      socket = null;
      joined = false;
      stopPing();
      if (ws) {
        ws.onclose = null;
        ws.onmessage = null;
        try {
          ws.close();
        } catch (e) {}
      }
      handlers.onDisconnected();
      scheduleReconnect();
    }

    function scheduleReconnect() {
      if (stopped || reconnectTimer) {
        return;
      }
      reconnectTimer = setTimeout(function () {
        reconnectTimer = null;
        connect();
      }, reconnectDelay);
      reconnectDelay = Math.min(reconnectDelay * 2, 10000);
    }

    function startPing() {
      stopPing();
      pingTimer = setInterval(function () {
        if (Date.now() - lastSeen > DUAL_PONG_TIMEOUT) {
          drop();
          return;
        }
        send({ type: 'dual.ping' });
      }, DUAL_PING_INTERVAL);
    }

    function stopPing() {
      if (pingTimer) {
        clearInterval(pingTimer);
        pingTimer = null;
      }
    }

    function send(message) {
      if (!socket || socket.readyState !== WebSocket.OPEN || !joined) {
        return false;
      }
      socket.send(JSON.stringify(message));
      return true;
    }

    return { connect: connect, send: send };
  }

  // Helpers shared by master and slave; the slave's grid is the same server-rendered markup as the master's

  function dualActiveCategoryId() {
    const $active = $('.tablinks.active').first();
    return $active.length ? String($active.attr('data-category-id')) : DUAL_ALL_CATEGORY;
  }

  function dualPane(categoryId) {
    return $('#category-tabcontent-' + categoryId + ' #category-' + categoryId);
  }

  function dualTiles($pane) {
    return $pane.children('.shop-product-container');
  }

  function dualTileKey($tile) {
    const productId = $tile.attr('data-product-id');
    if (productId) {
      return 'p' + productId;
    }
    const subCategoryId = $tile.find('.sub_product_category_card_btn').attr('data-sub-product-category-id');
    return subCategoryId ? 's' + subCategoryId : '';
  }

  // Every product of a category in one list: the POS endpoint is paginated, so read page
  // after page until a page adds nothing new or fails. The pages put sub-categories first, so the
  // tiles are then sorted in the group's saved order, as on the POS's first page. Resolves with the HTML.
  // sort: the POS sort menu's choice ('' = saved order); the pages then come sorted by the server.
  function dualLoadAllProducts(categoryId, sort) {
    const seen = {};
    const tiles = [];
    let pageSize = 0;

    function loadPage(page) {
      const formData = new FormData();
      formData.append('page', page);
      formData.append('search_string', '');
      formData.append('category_id', categoryId);
      formData.append('location_id', $('#location-id').val());
      formData.append('pos_sort', sort || '');
      return $.ajax({
        type: 'POST',
        url: '/api/v1/private/products/get-category-products',
        data: formData,
        cache: false,
        processData: false,
        contentType: false,
      }).then(function (data) {
        let added = 0;
        const $tiles = $('<div>')
          .html((data && data.products_html) || '')
          .children('.shop-product-container');
        pageSize = pageSize || $tiles.length;
        $tiles.each(function () {
          const key = dualTileKey($(this));
          if (key && !seen[key]) {
            seen[key] = true;
            tiles.push({ key: key, html: this.outerHTML });
            added++;
          }
        });
        // A short page is the last one
        if (added === 0 || $tiles.length < pageSize || page >= DUAL_MAX_PAGES) {
          return null;
        }
        return loadPage(page + 1);
      }, function () {
        // Past the last page the endpoint answers with an error: keep what was loaded
        return null;
      });
    }

    const order = categoryId === DUAL_ALL_CATEGORY || sort
      ? $.Deferred().resolve([]).promise()
      : $.ajax({
          type: 'GET',
          url: '/api/v1/private/dual-screen/category-order',
          data: { category_id: categoryId },
          cache: false,
        }).then(function (data) {
          return (data && data.keys) || [];
        }, function () {
          return $.Deferred().resolve([]).promise();
        });

    return $.when(loadPage(1), order).then(function (pagesDone, keys) {
      const position = {};
      (keys || []).forEach(function (key, index) {
        if (position[key] === undefined) {
          position[key] = index;
        }
      });
      // Saved order first; anything without a saved position keeps its place after them
      const sorted = tiles
        .map(function (tile, index) {
          return { tile: tile, index: index, position: position[tile.key] };
        })
        .sort(function (a, b) {
          const aPos = a.position === undefined ? Infinity : a.position;
          const bPos = b.position === undefined ? Infinity : b.position;
          return aPos === bPos ? a.index - b.index : aPos - bPos;
        });
      return sorted
        .map(function (item) {
          return item.tile.html;
        })
        .join('');
    });
  }

  // The category tabs the page was rendered with; a slave whose tabs differ from the master's reloads
  function dualTabsSignature() {
    return $('.tablinks')
      .map(function () {
        return String($(this).attr('data-category-id'));
      })
      .get()
      .join(',');
  }

  function dualUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  /**
   * Master: shows the products the slave has no room for, sends its screen state to the slave, and runs slave taps
   * through the normal add-to-cart handler so every cart rule still applies.
   */
  function initDualMaster($pos, messages) {
    let locked = false;
    let slaveOnline = false;
    let lastSentState = '';
    // New on every page load: tells the slave to reload its product lists so it matches this page
    const loadId = dualUuid();
    const tabsSignature = dualTabsSignature();
    // Product keys the slave shows per category; the master leaves those out of its own grid
    let slaveKeys = {};
    const handledTapIds = [];

    const connection = createDualConnection({
      onInfo: function () {},
      onUnpaired: function () {},
      onMessage: function (data) {
        switch (data.type) {
          case 'dual.welcome':
          case 'dual.peer':
            slaveOnline = data.type === 'dual.welcome' ? !!data.peerOnline : !!data.online;
            if (!slaveOnline) {
              slaveKeys = {};
            }
            applySplit();
            sendState(true);
            break;
          case 'dual.request_state':
            sendState(true);
            break;
          case 'dual.layout':
            handleLayout(data);
            break;
          case 'dual.tap':
            handleTap(data);
            break;
        }
      },
      onDisconnected: function () {
        slaveOnline = false;
        slaveKeys = {};
        applySplit();
      },
    });

    function handleLayout(data) {
      const categoryId = String(data.categoryId || DUAL_ALL_CATEGORY);
      const keys = {};
      (Array.isArray(data.keys) ? data.keys : []).forEach(function (key) {
        keys[String(key)] = true;
      });
      slaveKeys[categoryId] = keys;
      applySplit();
    }

    // The slave's products are left out here, so the two pads together show the category once.
    // Search results are always shown in full: the slave does not show them.
    function applySplit() {
      const split = slaveOnline && !locked && !isSearching();
      $('#product-list .category-tabcontent').each(function () {
        const categoryId = String(this.id).replace('category-tabcontent-', '');
        const keys = split ? slaveKeys[categoryId] : null;
        dualTiles(dualPane(categoryId)).each(function () {
          const $tile = $(this);
          $tile.toggleClass('dual-on-slave', !!keys && !!keys[dualTileKey($tile)]);
        });
      });
    }

    function buildState() {
      return {
        type: 'dual.state',
        locationId: String($('#location-id').val()),
        posUrl: window.location.pathname + window.location.search,
        categoryId: dualActiveCategoryId(),
        sort: currentSort(dualActiveCategoryId()),
        locked: locked,
        loadId: loadId,
        tabs: tabsSignature,
        productsPerRow: parseInt($pos.attr('data-products-per-row'), 10) || null,
      };
    }

    function sendState(force) {
      const state = buildState();
      const json = JSON.stringify(state);
      if (!force && json === lastSentState) {
        return;
      }
      if (connection.send(state)) {
        lastSentState = json;
      }
    }

    function refresh(force) {
      sendState(force);
    }

    function cartSnapshot() {
      try {
        if (typeof locationCart === 'undefined' || !locationCart) {
          return '';
        }
        return [
          locationCart.number_of_products,
          locationCart.amount,
          (locationCart.products || []).length,
        ].join(':');
      } catch (e) {
        return '';
      }
    }

    // Prefer the product in the same category pane as on the slave, then any pane, then the hidden copy
    function findTile(data) {
      const byKey = function () {
        return dualTileKey($(this)) === data.key;
      };
      const $sameCategory = dualTiles(dualPane(String(data.categoryId || DUAL_ALL_CATEGORY))).filter(byKey);
      if ($sameCategory.length) {
        return $sameCategory.first();
      }
      const $anywhere = $('#product-list .category-tabcontent .shop-product-container, #dual-screen-product-buffer .shop-product-container').filter(byKey);
      return $anywhere.length ? $anywhere.first() : null;
    }

    // The slave lists every product, the master only its current page: keep a hidden copy of all of them
    function loadProductBuffer() {
      dualLoadAllProducts(DUAL_ALL_CATEGORY).then(function (html) {
        let $buffer = $('#dual-screen-product-buffer');
        if (!$buffer.length) {
          $buffer = $('<div id="dual-screen-product-buffer" hidden></div>').appendTo('body');
        }
        $buffer.html(html);
      });
    }

    // Presses from the slave follow the tap rules of this pad's tiles (ProductCard.js): with quick order on,
    // a second press within 300 ms is the double tap (quick order). A single press adds only once that window
    // has passed, so a double press never adds the product twice (one quick order, quantity 1)
    const pendingPresses = {};
    function handlePress($tile, key) {
      const $add = $tile.find('.add-product').first();
      const quickOrder = !!$('#product-list').data('enable-double-click-quick-order');
      if (!quickOrder) {
        $add.trigger('click');
        return;
      }
      const now = Date.now();
      const previous = pendingPresses[key];
      if (previous) {
        clearTimeout(previous.timer);
        delete pendingPresses[key];
        const gap = now - previous.at;
        if (gap < 300 && gap > 50) {
          $tile.find('.shop-product').first().trigger('dblclick');
          return;
        }
      }
      pendingPresses[key] = {
        at: now,
        timer: setTimeout(function () {
          delete pendingPresses[key];
          $add.trigger('click');
        }, 300),
      };
    }

    function handleTap(data) {
      const tapId = String(data.tapId || '');
      if (!tapId || handledTapIds.indexOf(tapId) !== -1) {
        return;
      }
      handledTapIds.push(tapId);
      if (handledTapIds.length > 200) {
        handledTapIds.shift();
      }

      const ack = function (result, message) {
        connection.send({ type: 'dual.tap_ack', tapId: tapId, result: result, message: message || '' });
      };

      if (locked) {
        ack('rejected', messages.locked);
        return;
      }
      if ($('.modal.show').length) {
        ack('busy', messages.busy);
        return;
      }
      const $tile = findTile(data);
      if (!$tile) {
        sendState(true);
        ack('rejected', messages.stale);
        return;
      }

      const before = cartSnapshot();
      const action = data.action || 'tap';
      const $subCategory = $tile.find('.sub_product_category_card_btn');
      if ($subCategory.length) {
        $subCategory.trigger('click.subCategory');
      } else if (action === 'extras' && typeof getClassicProductExtraModal === 'function') {
        // Same as a hold released early on this pad
        getClassicProductExtraModal($tile.attr('data-product-id'));
      } else if (action === 'press') {
        handlePress($tile, data.key);
      } else {
        const $add = $tile.find('.add-product').first();
        if (!$add.length) {
          ack('rejected', messages.not_added);
          return;
        }
        $add.trigger('click');
      }

      // Added at once, or a modal (extras, weight, open price) opens here on the master
      const start = Date.now();
      (function check() {
        if (cartSnapshot() !== before) {
          ack('added');
        } else if ($('.modal.show').length) {
          ack('modal', messages.continue_on_master);
        } else if (Date.now() - start > 600) {
          ack('done');
        } else {
          setTimeout(check, 30);
        }
      })();
    }

    function isSearching() {
      return $.trim($('#search_string').val() || '') !== '';
    }

    function currentSort(categoryId) {
      return typeof getPosProductSort === 'function' ? getPosProductSort(categoryId) : '';
    }

    // No pages next to the slave: the whole group in one scrolling grid. Search results keep their pages.
    // A search replaces the panes, so a fresh pane (without the flag) is loaded again.
    // force: load again in the current sort order (sort menu), even when already loaded.
    function loadFullPane(categoryId, force) {
      const $tabContent = $('#category-tabcontent-' + categoryId);
      if (!$tabContent.length || isSearching() || (!force && $tabContent.data('dualFull'))) {
        return;
      }
      if (!force && !$.trim($tabContent.children('.pagenation-container').html() || '')) {
        // Only one page: already complete
        $tabContent.data('dualFull', true);
        return;
      }
      $tabContent.data('dualFull', true);
      // Only the newest load fills the pane (the sort can change while one is running)
      const request = {};
      $tabContent.data('dualFullRequest', request);
      dualLoadAllProducts(categoryId, currentSort(categoryId)).then(function (html) {
        if ($tabContent.data('dualFullRequest') !== request) {
          return;
        }
        // Skip when a search replaced the pane or started meanwhile
        if (!html || !$.contains(document, $tabContent[0]) || isSearching()) {
          $tabContent.data('dualFull', false);
          return;
        }
        const $pane = dualPane(categoryId);
        $pane.html(html);
        $tabContent.addClass('dual-full-list');
        if (typeof initProductCardHoldToConfirm === 'function') {
          initProductCardHoldToConfirm(dualTiles($pane));
        }
        applySplit();
      });
    }

    loadProductBuffer();
    loadFullPane(dualActiveCategoryId());

    // Sort menu (ProductCategorySearch.js): reload the whole group in the new order instead of only its
    // first page, so the master and the slave (which follows the sort in the state) stay one sorted list
    window.dualScreenLoadCategoryProducts = function (categoryId) {
      if (isSearching() || !$('#category-tabcontent-' + categoryId).length) {
        return false;
      }
      loadFullPane(String(categoryId), true);
      return true;
    };
    $(document).on('pos-product-sort-change', function () {
      refresh(false);
    });

    // Product group chosen here: the slave shows that group (selectCategory() already ran from the inline onclick)
    $(document).on('click', '.tablinks', function () {
      loadFullPane(dualActiveCategoryId());
      refresh(false);
    });

    // Search, pagination and the POS's own reloads replace the grid: leave the slave's products out again
    $(document).ajaxComplete(function () {
      loadFullPane(dualActiveCategoryId());
      applySplit();
    });

    // PIN out: blank the slave before the PIN screen loads
    $(document).on('click', 'a[href*="/user/organizer_login"]', function () {
      locked = true;
      applySplit();
      refresh(true);
    });

    connection.connect();
  }

  /**
   * Slave: shows the first products of the group chosen on the master ("all" at first), as many as fit without scrolling,
   * and sends product taps to the master instead of adding to its own cart.
   */
  function initDualSlave($pos, messages) {
    const $status = $('#dual-screen-status');
    const pendingTaps = {};
    let masterName = '';
    let lastState = null;
    let masterLoadId = null;
    let lastSentLayout = '';

    function setBlank(text) {
      $pos.addClass('dual-blank').toggleClass('dual-show-status', !!text);
      $status.text(text || '');
    }

    // One message for every state out of sync with the master (connecting, offline, PIN out, switched off)
    function notSyncedText() {
      return (messages.not_synced || '').replace('{master}', masterName);
    }

    const connection = createDualConnection({
      onInfo: function (data) {
        masterName = data.master_name || '';
        setBlank(notSyncedText());
      },
      onUnpaired: function () {
        setBlank(messages.no_master);
      },
      onMessage: function (data) {
        switch (data.type) {
          case 'dual.welcome':
            lastSentLayout = '';
            if (data.peerOnline) {
              connection.send({ type: 'dual.request_state' });
            } else {
              setBlank(notSyncedText());
            }
            break;
          case 'dual.peer':
            lastSentLayout = '';
            if (data.online) {
              connection.send({ type: 'dual.request_state' });
            } else {
              lastState = null;
              setBlank(notSyncedText());
            }
            break;
          case 'dual.state':
            applyState(data);
            break;
          case 'dual.tap_ack':
            finishTap(data.tapId, data.result, data.message);
            break;
        }
      },
      onDisconnected: function () {
        lastState = null;
        setBlank(notSyncedText());
        Object.keys(pendingTaps).forEach(function (tapId) {
          finishTap(tapId, 'timeout');
        });
      },
    });

    // Each category's full product list is loaded once per master page load and sort order, so it matches the master
    let fullListLoaded = {};
    let shownCategory = null;

    // The master's sort applies to the group it shows; every other group is in its saved order
    function wantedSort(categoryId) {
      return lastState && String(lastState.categoryId || DUAL_ALL_CATEGORY) === categoryId ? String(lastState.sort || '') : '';
    }

    function loadFullList(categoryId) {
      const sort = wantedSort(categoryId);
      if (fullListLoaded[categoryId] && fullListLoaded[categoryId].sort === sort) {
        return;
      }
      const marker = { sort: sort };
      fullListLoaded[categoryId] = marker;
      lastSentLayout = '';
      dualLoadAllProducts(categoryId, sort).then(function (html) {
        if (fullListLoaded[categoryId] !== marker) {
          // Reloaded for a newer master page in the meantime
          return;
        }
        if (html) {
          const $pane = dualPane(categoryId);
          $pane.html(html);
          if (typeof initProductCardHoldToConfirm === 'function') {
            initProductCardHoldToConfirm(dualTiles($pane));
          }
          if (categoryId === shownCategory) {
            fitAndReport();
          }
        } else {
          fullListLoaded[categoryId] = false;
        }
      });
    }

    // Lowest visible edge of the grid: the screen, or a scrolling/clipping parent of the grid
    function visibleBottom(element) {
      let bottom = window.innerHeight || document.documentElement.clientHeight;
      for (let node = element; node && node !== document.body; node = node.parentElement) {
        const overflowY = window.getComputedStyle(node).overflowY;
        if (overflowY !== 'visible') {
          bottom = Math.min(bottom, node.getBoundingClientRect().bottom);
        }
      }
      return bottom;
    }

    // Show only the products that fit on this screen without scrolling and tell the master which they are,
    // so the master shows the rest
    function fitAndReport() {
      if (!shownCategory || $pos.hasClass('dual-blank')) {
        return;
      }
      const $pane = dualPane(shownCategory);
      const $tiles = dualTiles($pane);
      $tiles.removeClass('dual-not-on-slave');
      if (!$pane.length || !$pane.is(':visible')) {
        return;
      }
      $('#category-tabcontent-' + shownCategory).scrollTop(0);

      const bottom = visibleBottom($pane[0]);
      const keys = [];
      let full = false;
      $tiles.each(function () {
        if (!full && this.getBoundingClientRect().bottom <= bottom + 1) {
          const key = dualTileKey($(this));
          if (key) {
            keys.push(key);
          }
        } else {
          full = true;
          $(this).addClass('dual-not-on-slave');
        }
      });

      const layout = { type: 'dual.layout', categoryId: shownCategory, keys: keys };
      const json = JSON.stringify(layout);
      if (json !== lastSentLayout && connection.send(layout)) {
        lastSentLayout = json;
      }
    }

    let resizeTimer = null;
    $(window).on('load resize orientationchange', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitAndReport, 200);
    });

    // The category panes arrive with the POS's own product request; wait for them if needed
    function showCategory(categoryId, attempt) {
      if (!$('#category-tabcontent-' + categoryId).length) {
        if ((attempt || 0) < 40) {
          setTimeout(function () {
            if (lastState && String(lastState.categoryId || DUAL_ALL_CATEGORY) === categoryId) {
              showCategory(categoryId, (attempt || 0) + 1);
            }
          }, 250);
        }
        return;
      }
      $('.tabcontent').hide();
      $('#category-tabcontent-' + categoryId).css('display', 'block').scrollTop(0);
      $('.tablinks').removeClass('active');
      $('#category-' + categoryId + '-tab').addClass('active');
      shownCategory = categoryId;
      fitAndReport();
      loadFullList(categoryId);
    }

    // Without its own "Antall produkter per rad" this pad uses the master's: when the master comes back
    // with another value, swap the grid's styles in place instead of reloading
    let productsPerRow = parseInt($pos.attr('data-products-per-row'), 10) || null;
    let productsPerRowRequest = null;
    function followProductsPerRow(masterValue) {
      const value = parseInt(masterValue, 10);
      if ($pos.attr('data-own-products-per-row') === '1' || !value || value === productsPerRow || value === productsPerRowRequest) {
        return;
      }
      productsPerRowRequest = value;
      $.ajax({
        type: 'GET',
        url: '/api/v1/private/dual-screen/grid-style',
        data: { products_per_row: value },
        cache: false,
      })
        .done(function (data) {
          if (productsPerRowRequest !== value || !data || !data.css) {
            return;
          }
          // Scoped to this pad so it wins over the grid styles the page was rendered with
          const css = data.css.replace(/\.category-product-grid/g, "#classic-location-products[data-dual-role='slave'] .category-product-grid");
          $('#dual-screen-grid-style').remove();
          $(css).attr('id', 'dual-screen-grid-style').appendTo('head');
          productsPerRow = value;
          $pos.attr('data-products-per-row', value);
          fitAndReport();
        })
        .always(function () {
          if (productsPerRowRequest === value) {
            productsPerRowRequest = null;
          }
        });
    }

    function applyState(state) {
      lastState = state;

      if (state.locked) {
        setBlank(notSyncedText());
        return;
      }
      if (String(state.locationId) !== String($('#location-id').val())) {
        // Follow the master to its location
        try {
          if (sessionStorage.getItem('dualScreenFollowUrl') === state.posUrl) {
            setBlank(notSyncedText());
            return;
          }
          sessionStorage.setItem('dualScreenFollowUrl', state.posUrl);
        } catch (e) {}
        window.location.href = state.posUrl;
        return;
      }
      try {
        sessionStorage.removeItem('dualScreenFollowUrl');
      } catch (e) {}

      // The master was loaded with other product groups (Varevisning POS changed): reload to get them,
      // once per set of groups so differing groups cannot cause a reload loop
      if (state.tabs !== undefined && state.tabs !== dualTabsSignature()) {
        let reloadedFor = null;
        try {
          reloadedFor = sessionStorage.getItem('dualScreenTabsReload');
          sessionStorage.setItem('dualScreenTabsReload', state.tabs);
        } catch (e) {}
        if (reloadedFor !== state.tabs) {
          window.location.reload();
          return;
        }
      }

      // A new master page load may have new products or prices: load the lists again
      if (state.loadId && state.loadId !== masterLoadId) {
        masterLoadId = state.loadId;
        fullListLoaded = {};
        lastSentLayout = '';
        if (shownCategory) {
          loadFullList(shownCategory);
        }
      }

      followProductsPerRow(state.productsPerRow);

      const categoryId = String(state.categoryId || DUAL_ALL_CATEGORY);
      const wasBlank = $pos.hasClass('dual-blank');
      $pos.removeClass('dual-blank dual-show-status');
      if (categoryId !== shownCategory || wasBlank) {
        showCategory(categoryId);
      } else {
        // The master may have just come back and forgotten what this pad shows
        fitAndReport();
        // Sort chosen on the master: show the group in that order
        loadFullList(categoryId);
      }
    }

    // action: 'press' (a tap on the tile), 'tap' (add to cart) or 'extras' (extras popup)
    function sendTap($tile, action) {
      if (!lastState || $pos.hasClass('dual-blank')) {
        return;
      }

      const tapId = dualUuid();
      $tile.addClass('dual-tap-pending');
      pendingTaps[tapId] = {
        $tile: $tile,
        timer: setTimeout(function () {
          finishTap(tapId, 'timeout');
        }, DUAL_TAP_ACK_TIMEOUT),
      };

      const sent = connection.send({
        type: 'dual.tap',
        tapId: tapId,
        categoryId: shownCategory,
        key: dualTileKey($tile),
        action: action || 'tap',
      });
      if (!sent) {
        finishTap(tapId, 'timeout');
      }
    }

    function finishTap(tapId, result, message) {
      const pending = pendingTaps[tapId];
      if (!pending) {
        return;
      }
      delete pendingTaps[tapId];
      clearTimeout(pending.timer);

      const ok = result === 'added' || result === 'done' || result === 'modal';
      const flashClass = ok ? 'dual-tap-ok' : 'dual-tap-fail';
      pending.$tile.removeClass('dual-tap-pending').addClass(flashClass);
      setTimeout(function () {
        pending.$tile.removeClass(flashClass);
      }, ok ? 300 : 1200);

      if (result === 'modal' || !ok) {
        showToast({
          type: ok ? 'info' : 'error',
          title: '',
          message: message || messages.not_added,
          position: 'bottom-center',
          duration: 2500,
        });
      }
    }

    // The tiles keep every gesture they have on the master (tap animation, hold ring, double tap, product
    // details on a full hold, sub-category popup). Only what touches the cart is sent to the master instead:
    // these handlers sit below the document, so they run before the POS's own document-level handlers.
    const $content = $('#content');
    function tileOf(element) {
      const $tile = $(element).closest('.shop-product-container');
      return $tile.length && $tile.closest('#product-list, #pos-sub-product-category-product-modal').length ? $tile : null;
    }

    // A press on a tile goes to the master as it is; the master applies its own tap and double-tap
    // (quick order) rules, so a double press is one quick order there, as on the master's own tiles.
    // The slave's own tap handler would otherwise add once more before the double tap is recognised.
    const tileButton = '.shop-product-container .shop-product';
    let touchStart = null;
    let ignoreClickUntil = 0;

    function pressTarget(button) {
      return $(button).hasClass('sub_product_category_card_btn') ? null : tileOf(button);
    }

    $content.on('touchstart', tileButton, function (e) {
      const touch = e.originalEvent.touches[0];
      touchStart = { button: this, x: touch.clientX, y: touch.clientY, at: Date.now() };
    });

    $content.on('touchend', tileButton, function (e) {
      const $tile = pressTarget(this);
      if (!$tile) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      ignoreClickUntil = Date.now() + 700;
      const start = touchStart;
      touchStart = null;
      if (!start || start.button !== this) {
        return;
      }
      const touch = e.originalEvent.changedTouches[0];
      const moved = Math.abs(touch.clientX - start.x) > 10 || Math.abs(touch.clientY - start.y) > 10;
      // From 250 ms the hold ring takes over: extras popup or product details, as on the master
      if (!moved && Date.now() - start.at < 250) {
        sendTap($tile, 'press');
      }
    });

    // Mouse: a hold suppresses this click itself (hold ring), so a click is always a press
    $content.on('click', tileButton, function (e) {
      const $tile = pressTarget(this);
      if (!$tile) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (Date.now() >= ignoreClickUntil) {
        sendTap($tile, 'press');
      }
    });

    $content.on('dblclick', tileButton, function (e) {
      if (pressTarget(this)) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    // Anything else on this pad that clicks a tile's add button adds on the master instead
    $content.on('click', '.add-product', function (e) {
      const $tile = tileOf(this);
      if (!$tile) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      sendTap($tile, 'tap');
    });

    // Hold released early: the extras popup belongs to the master's cart
    if (typeof window.getClassicProductExtraModal === 'function') {
      window.getClassicProductExtraModal = function (productId) {
        const $tile = $('#product-list .shop-product-container, #pos-sub-product-category-product-modal .shop-product-container')
          .filter(function () {
            return String($(this).attr('data-product-id')) === String(productId);
          })
          .first();
        if ($tile.length) {
          sendTap($tile, 'extras');
        }
      };
    }

    connection.connect();
  }
})();
